module.exports = __webpack_public_path__ + "static/media/discord.77b29e60.svg";